module.exports = __webpack_public_path__ + "img/2021_S.aace629b.png";